"use client";
import { memo, useEffect, useRef, useState } from "react";
import Image from "next/image";
import { motion } from "framer-motion";

function SuitabilityChatBubble({ message, onComplete }: { message: string; onComplete: () => void }) {
  const [typedMessage, setTypedMessage] = useState("");

  const onCompleteRef = useRef(onComplete);
  const doneRef = useRef(false);

  useEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);

  useEffect(() => {
    setTypedMessage("");
    doneRef.current = false;

    let i = 0;
    let current = "";

    const interval = setInterval(() => {
      current += message.charAt(i);
      setTypedMessage(current);
      i++;
      if (i >= message.length) {
        clearInterval(interval);
        if (!doneRef.current) {
          doneRef.current = true;
          onCompleteRef.current();
        }
      }
    }, 15);

    return () => clearInterval(interval);
  }, [message]);

  return (
    <div className="flex items-start gap-1 overflow-hidden">
      <Image
        src="/next_assets/images/suitability-modal/chatbox-user-avatar.png"
        alt="ChatBot Porfile Image"
        width={40}
        height={40}
        className="rounded-full"
      />
      <motion.div
        initial={{ maxWidth: 0, padding: 0, opacity: 0 }}
        animate={{ maxWidth: "85%", padding: "10px", opacity: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="bg-[#F0F2FF] text-primaryBlack p-2.5 rounded-xl text-left text-2xs leading-4 font-medium whitespace-pre-wrap"
      >
        {typedMessage}
      </motion.div>
    </div>
  );
}

// onComplete is read through a ref, so only a new message needs a re-render
export default memo(SuitabilityChatBubble, (prev, next) => prev.message === next.message);
